(function () {
	const win = window;
	if (win.__brModalProjetoInit) return;
	win.__brModalProjetoInit = true;

	const PORTAL_ID = "39596724";
	const FORM_ID = "3292b6ad-3399-4361-b6b9-f2a469edf7a4";
	const EARLY_CAPTURE_FORM_ID = "";
	const FILE_FORM_ID = "f4ac284f-17b8-49a3-a3bc-a7c2f4a2f62c";
	const FILE_FIELD = "arquivos_cozinha";

	const SUBMIT_BASE = "https://api.hsforms.com/submissions/v3/integration/submit/" + PORTAL_ID + "/";
	const SUBMIT_URL = SUBMIT_BASE + FORM_ID;
	const EARLY_CAPTURE_SUBMIT_URL = EARLY_CAPTURE_FORM_ID ? SUBMIT_BASE + EARLY_CAPTURE_FORM_ID : "";
	const FILE_UPLOAD_URL = "https://forms.hubspot.com/uploads/form/v2/" + PORTAL_ID + "/" + FILE_FORM_ID;

	const FIELD_MAP = {
		nome: "firstname",
		email: "email",
		telefone: "phone",
		formato: "qual_o_formato_da_cozinha_dos_seus_sonhos_",
		medidas: "possui_as_medidas___texto_",
		linha: "qual_a_linha_que_voce_gostou_mais_",
		cor: "qual_deve_ser_a_cor_da_sua_cozinha___multiplos_valores_",
		eletro: "selecione_os_eletrodomesticos_que_vao_compor_o_ambiente",
		bancada: "voce_possui_ou_pretende_utilizar_uma_pia_ou_bancada_de_marmore_na_sua_cozinha_",
		profundidade: "profundidade_da_bancada",
		espaco: "o_seu_espaco_ja_esta_pronto_para_receber_a_sua_cozinha_nova",
		data_compra: "quando_voce_quer_realizar_a_compra_da_sua_cozinha_",
		orcamento: "qual_o_orcamento_esta_disponivel_para_a_cozinha_dos_seus_sonhos_",
		cta: "pdp_"
	};

	const VALUE_MAP = {
		formato: { "linear": "Linear", "em-canto": "Em canto", "em-u": "Em U", "paralela": "Paralela", "outro": "Outro formato" },
		linha: { "lux": "Lux", "vik": "Vik", "agata": "Agata", "glamy": "Glamy", "stella": "Stella", "reims": "Reims", "nice": "Nice", "acordes": "Acordes" },
		cor: { "branco": "Branco", "cinza": "Cinza", "preto": "Preto", "crema": "Crema", "amadeirado": "Amadeirado", "azul": "Azul", "verde": "Verde" },
		eletro: {
			"geladeira": "Geladeira", "microondas": "Microondas", "forno-embutir": "Forno de embutir",
			"forno-eletrico": "Forno elétrico", "fogao": "Fogão", "cooktop-inducao": "Cooktop ou Indução",
			"coifa": "Coifa", "lava-louca": "Lava louça", "depurador": "Depurador"
		},
		bancada: { "sim": "Sim, possuo.", "nao-mas-quer": "Não, mas vou adquirir", "nao-precisa": "Não tenho necessidade" },
		profundidade: { "52": "52cm", "60": "60cm" },
		espaco: { "sim": "Sim", "nao": "Não" },
		orcamento: {
			"2000-3500": "R$ 2.000 a R$ 3.500",
			"3500-5000": "R$ 3.500 a R$ 5.000",
			"5000-8000": "R$ 5.000 a R$ 8.000",
			"8000+": "Mais de R$ 8.000"
		}
	};

	const HIDDEN_FIELDS = [
		{ name: "madesa_email_consent", value: "true" },
		{ name: "nacionalidade", value: "Brasil" }
	];

	const ORIGIN_STAGING_NORMAL = [
		{ name: "origem_de_cadastro_staging", value: "LP Cozinhas (Quiz)" },
		{ name: "origem_de_cadastro__crm__staging", value: "LP (Quiz)" }
	];

	const ORIGIN_EXIT = "LP (Quiz) Desistentes";
	const NEVER_SEND_DIRECTLY = ["origem_de_cadastro", "origem_de_cadastro__crm_"];

	const LEGAL_CONSENT = {
		consent: {
			consentToProcess: true,
			text: "Para prestar o serviço, precisamos da sua autorização para armazenar e processar seus dados pessoais.",
			communications: [
				{ value: true, subscriptionTypeId: 2924505825, text: "Concordo em receber comunicações da Madesa." }
			]
		}
	};

	const EXIT_FIELD = "etapa_de_desistencia";
	const EXIT_STEP = {
		2: "formato", 3: "medidas", 4: "linha", 5: "cor-frente", 6: "eletrodomesticos",
		7: "pia-marmore", 8: "pia-profundidade", 9: "espaco-pronto", 10: "data-compra", 11: "orcamento"
	};

	const STEP_EVENTS = {
		1: "contato_projeto", 2: "formato_cozinha_modal", 3: "medidas_modal", 4: "linha_cozinha_modal",
		5: "cor_cozinha_modal", 6: "eletrodomesticos_modal", 7: "bancada_modal", 8: "profundidade_modal",
		9: "pronto_modal", 10: "periodo_modal"
	};

	const WALLS_BY_FORMAT = { "linear": 1, "em-canto": 2, "em-u": 3, "paralela": 2 };
	const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
	const SINGLE_CHOICE_STEPS = { 2: "formato", 4: "linha", 7: "bancada", 8: "profundidade", 9: "espaco", 11: "orcamento" };
	const REQUIRED_STEPS = [1, 2, 5, 8, 9, 10, 11];
	const MAX_FILE_MB = 100;
	const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;
	const STORAGE_KEY = "br-modal-projeto-progress";
	const OPEN_HASH = "#br-projeto-cozinha";
	const OPEN_SELECTOR = `[data-br-projeto-open], [data-project-start-open], a[href$="${OPEN_HASH}"]`;
	const STORAGE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

	const modal = document.getElementById("br-modal-projeto");
	const backBtn = document.getElementById("br-modal-back-btn");
	const closeBtn = document.getElementById("br-modal-close-btn");
	if (!modal || !backBtn || !closeBtn) return;

	const container = modal.querySelector(".br-modal-container");
	const confirmOverlay = document.getElementById("br-modal-confirm-exit");
	const confirmTitle = document.getElementById("br-modal-confirm-title");
	const confirmMessage = document.getElementById("br-modal-confirm-message");
	const confirmStayBtn = document.getElementById("br-modal-confirm-stay-btn");
	const confirmSkipBtn = document.getElementById("br-modal-confirm-skip-btn");
	const confirmLeaveBtn = document.getElementById("br-modal-confirm-leave-btn");
	const successCloseBtn = document.getElementById("br-modal-success-close-btn");
	const dateSelect = modal.querySelector('select[name="data-compra"]');
	const depthCustom = modal.querySelector('input[name="step8_depth_custom"]');

	let i18n = {};
	try {
		const raw = document.getElementById("br-modal-projeto-i18n");
		if (raw && raw.textContent) i18n = JSON.parse(raw.textContent.trim());
	} catch (e) {
		i18n = {};
	}

	const totalSteps = i18n.totalSteps > 0 ? i18n.totalSteps : 11;
	const formData = {};
	let uploadedFiles = [];
	let currentStep = 0;
	let isSubmitting = false;
	let leadCaptured = false;

	const PAID_MEDIUM = /^(cpc|ppc|cpm|cpv|cpa|cpl|display|banner|retargeting|remarketing|ads?|shopping|paid[\w-]*|[\w-]*[-_]paid)$/i;
	const CLICK_IDS = [
		{ param: "gclid", source: "google", medium: "cpc" },
		{ param: "gbraid", source: "google", medium: "cpc" },
		{ param: "wbraid", source: "google", medium: "cpc" },
		{ param: "fbclid", source: "facebook", medium: "paid" },
		{ param: "ttclid", source: "tiktok", medium: "paid" },
		{ param: "msclkid", source: "bing", medium: "cpc" }
	];

	function paidOrigin(params) {
		const get = (key) => (params.get(key) || "").trim().toLowerCase();
		const click = CLICK_IDS.find((c) => params.get(c.param));
		let source = get("utm_source");
		let medium = get("utm_medium");
		const campaign = get("utm_campaign");
		if (!PAID_MEDIUM.test(medium) && !click) return "";
		if (!source && click) source = click.source;
		if (!medium && click) medium = click.medium;
		return [source, medium, campaign].filter(Boolean).join(" / ").slice(0, 255);
	}

	const attribution = (function readUrlParams() {
		let params;
		try { params = new URLSearchParams(window.location.search); } catch (e) { params = new URLSearchParams(""); }
		const gclid = params.get("gclid") || "";
		const cta = (params.get("cta") || "").trim().slice(0, 255) || paidOrigin(params);
		try {
			if (gclid) sessionStorage.setItem("__br_gclid", gclid);
			if (cta) sessionStorage.setItem("__br_madesa_cta", cta);
			return {
				gclid: gclid || sessionStorage.getItem("__br_gclid") || sessionStorage.getItem("__gclid") || "",
				cta: cta || sessionStorage.getItem("__br_madesa_cta") || sessionStorage.getItem("__madesa_cta") || ""
			};
		} catch (e) {
			return { gclid, cta };
		}
	})();

	const $ = (sel) => modal.querySelector(sel);
	const $$ = (sel) => Array.from(modal.querySelectorAll(sel));
	const stepEl = (step) => $(`.br-form-step[data-step="${step}"]`);
	const digits = (value) => `${value || ""}`.replace(/\D/g, "");
	const cmSuffix = () => (typeof i18n.unitCmSuffix === "string" ? i18n.unitCmSuffix : " cm");

	function getHutk() {
		const m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
		return m ? m[2] : "";
	}

	function track(eventName) {
		try {
			if (typeof win.trackEvent === "function") win.trackEvent(eventName, {});
		} catch (e) {}
		if (eventName === "contato_projeto") {
			win.dataLayer = win.dataLayer || [];
			win.dataLayer.push({
				event: "lead_projeto",
				email: `${formData.email || ""}`.trim().toLowerCase(),
				phone_number: `${formData.telefone || ""}`.trim(),
				first_name: `${formData.nome || ""}`.trim(),
				gclid: attribution.gclid || ""
			});
		}
	}

	function saveProgress() {
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify({ step: currentStep, formData, timestamp: Date.now() }));
		} catch (e) {}
	}

	function loadProgress() {
		try {
			const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
			if (!saved) return null;
			if (Date.now() - saved.timestamp > STORAGE_MAX_AGE) {
				localStorage.removeItem(STORAGE_KEY);
				return null;
			}
			return saved;
		} catch (e) {
			return null;
		}
	}

	function clearProgress() {
		try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
	}

	function formatProgress(step) {
		const tpl = i18n.progressTpl;
		if (!tpl) return `${step} / ${totalSteps}`;
		return tpl.replace(/__C__/g, String(step)).replace(/__T__/g, String(totalSteps));
	}

	function formatPhone(value) {
		const d = digits(value).slice(0, 11);
		if (!d) return "";
		if (d.length <= 2) return `(${d}`;
		if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
		if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
		return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
	}

	function isValidPhone(value) {
		const len = digits(value).length;
		return len === 10 || len === 11;
	}

	function isValidEmail(value) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(`${value || ""}`.trim());
	}

	function withCm(input) {
		const n = digits(input.value);
		input.value = n ? n + cmSuffix() : "";
		return n;
	}

	function bindCmInput(input) {
		input.addEventListener("input", () => {
			const n = withCm(input);
			if (n) input.setSelectionRange(n.length, n.length);
		});
		input.addEventListener("blur", () => withCm(input));
	}

	function setFieldError(field, hasError) {
		if (!field) return;
		field.classList.toggle("br-is-error", hasError);
	}

	function setGroupError(step, hasError) {
		const el = stepEl(step);
		if (el) el.classList.toggle("br-has-error", hasError);
	}

	function buildDateOptions() {
		if (!dateSelect) return;
		const now = new Date();
		const year = now.getFullYear();
		const month = now.getMonth();
		for (let i = 0; i <= 12; i += 1) {
			const d = new Date(year, month + i, 1);
			const option = document.createElement("option");
			option.value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
			option.textContent = `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
			dateSelect.appendChild(option);
		}
	}

	function renderStep3() {
		const inputs = $("[data-step3-inputs]");
		const preview = $(".br-step3-measure-preview");
		const image = $("[data-step3-illustration-image]");
		if (!inputs) return;

		const format = `${formData.formato || ""}`;
		const count = WALLS_BY_FORMAT[format] || 0;
		const wallTpl = i18n.step3WallLabelTpl || "Parede __N__";
		const placeholder = typeof i18n.step3PlaceholderCm === "string" ? i18n.step3PlaceholderCm : "__ cm";

		if (preview) preview.hidden = count === 0;
		inputs.innerHTML = "";

		for (let i = 1; i <= 3; i += 1) {
			if (i > count) {
				delete formData[`parede${i}`];
				continue;
			}
			const group = document.createElement("div");
			group.className = "br-form-group br-step3-form-group";

			const label = document.createElement("label");
			label.textContent = `${wallTpl.replace(/__N__/g, String(i))} `;
			const mark = document.createElement("span");
			mark.className = "br-step3-required-mark";
			mark.setAttribute("aria-hidden", "true");
			mark.textContent = "*";
			label.appendChild(mark);
			label.htmlFor = `br-step3-parede${i}`;

			const input = document.createElement("input");
			input.type = "text";
			input.inputMode = "numeric";
			input.id = `br-step3-parede${i}`;
			input.name = `parede${i}`;
			input.placeholder = placeholder;
			const saved = digits(formData[`parede${i}`]);
			input.value = saved ? saved + cmSuffix() : "";
			bindCmInput(input);

			group.appendChild(label);
			group.appendChild(input);
			inputs.appendChild(group);
		}

		if (image && preview) {
			const key = { "linear": "step3ImageLinear", "em-canto": "step3ImageEmCanto", "em-u": "step3ImageEmU", "paralela": "step3ImageParalela" }[format];
			const src = key ? preview.dataset[key] || "" : "";
			if (src) image.src = src;
			image.hidden = !src;
		}

		syncStep3();
	}

	function syncStep3() {
		const isLater = formData.medidas_depois === "1";
		const checkbox = $('input[name="step3_medidas_depois"]');
		if (checkbox) {
			checkbox.checked = isLater;
			const option = checkbox.closest(".br-step3-later-option");
			if (option) option.classList.toggle("br-is-checked", isLater);
		}
		const inputs = $$('[data-step3-inputs] input');
		inputs.forEach((input) => {
			input.disabled = isLater;
			if (isLater) {
				input.value = "";
				setFieldError(input, false);
				delete formData[input.name];
			}
		});
		const row = $(".br-step3-measure-row");
		if (row) row.classList.toggle("br-is-disabled", isLater);
		const btn = $(".br-step3-advance-btn");
		if (btn) {
			const ready = isLater || hasAllStep3Measures();
			btn.disabled = !ready;
			btn.setAttribute("aria-disabled", ready ? "false" : "true");
		}
	}

	function renderStep5() {
		const line = `${formData.linha || ""}`;
		$$(".br-step5-color-btn").forEach((btn) => {
			const lines = (btn.getAttribute("data-lines") || "").split(",");
			btn.hidden = !!line && !lines.includes(line);
			if (btn.hidden) btn.classList.remove("active");
		});
		formData.cor = activeValues(5).join(",");
	}

	function activeValues(step) {
		const el = stepEl(step);
		return el ? Array.from(el.querySelectorAll(".br-option-btn.active")).map((b) => b.getAttribute("data-value") || "") : [];
	}

	function hasAllStep3Measures() {
		const inputs = $$('[data-step3-inputs] input');
		return inputs.length > 0 && inputs.every((input) => digits(input.value));
	}

	function updateToggleButtons(step) {
		const el = stepEl(step);
		if (!el) return;
		const next = el.querySelector(`.br-step${step}-advance-btn, .br-step${step}-next-btn`);
		const skip = el.querySelector(`.br-step${step}-skip-btn`);
		if (!next || !skip) return;
		let filled = false;
		if (step === 4 || step === 7) filled = activeValues(step).length > 0;
		if (step === 6) filled = !!el.querySelector('input[name="eletro"]:checked');
		next.hidden = !filled;
		skip.hidden = filled;
	}

	function isStepReady(step) {
		if (step === 1) {
			return !!($('input[name="nome"]').value.trim() && $('input[name="email"]').value.trim() && $('input[name="telefone"]').value.trim());
		}
		if (step === 8) return activeValues(8).length > 0 || !!digits(depthCustom && depthCustom.value);
		if (step === 10) return !!(dateSelect && dateSelect.value);
		return activeValues(step).length > 0;
	}

	function syncNextBtn(step) {
		if (!REQUIRED_STEPS.includes(step)) return;
		const el = stepEl(step);
		const btn = el && el.querySelector("[data-next-step]:not([class*='-skip-btn']), [data-submit]");
		if (btn) btn.classList.toggle("br-btn--pending", !isStepReady(step));
	}

	function activateOptions(step, values) {
		const el = stepEl(step);
		if (!el) return;
		el.querySelectorAll(".br-option-btn").forEach((btn) => {
			btn.classList.toggle("active", values.includes(btn.getAttribute("data-value")));
		});
	}

	function restoreUi() {
		["nome", "email", "telefone"].forEach((name) => {
			const input = $(`input[name="${name}"]`);
			if (input) input.value = formData[name] || "";
		});

		Object.keys(SINGLE_CHOICE_STEPS).forEach((step) => {
			const value = formData[SINGLE_CHOICE_STEPS[step]];
			activateOptions(Number(step), value ? [`${value}`] : []);
		});

		activateOptions(5, `${formData.cor || ""}`.split(",").filter(Boolean));

		const eletro = Array.isArray(formData.eletro) ? formData.eletro : [];
		$$('input[name="eletro"]').forEach((input) => {
			input.checked = eletro.includes(input.value);
			input.closest(".br-step6-appliance-card").classList.toggle("br-is-checked", input.checked);
		});

		if (depthCustom) {
			const custom = VALUE_MAP.profundidade[formData.profundidade] ? "" : digits(formData.profundidade);
			depthCustom.value = custom ? custom + cmSuffix() : "";
		}

		if (dateSelect) dateSelect.value = formData.data_compra || "";
	}

	function showStep(step) {
		const steps = $$(".br-form-step");
		steps.forEach((el) => el.classList.remove("active"));
		const active = steps[step];
		if (active) active.classList.add("active");

		if (container && active) {
			const name = active.getAttribute("data-step");
			container.setAttribute("data-active-step", name);
			container.classList.toggle("br-is-success-step", name === "success");
		}

		if (step > 0 && step <= totalSteps) {
			$$(".br-progress-counter").forEach((el) => { el.textContent = formatProgress(step); });
		}

		const content = $(".br-modal-content");
		if (content) content.scrollTop = 0;

		if (step === 3) renderStep3();
		if (step === 5) renderStep5();
		if (step === 4 || step === 6 || step === 7) updateToggleButtons(step);

		currentStep = step;
		syncNextBtn(step);
	}

	function resetForm() {
		Object.keys(formData).forEach((key) => delete formData[key]);
		uploadedFiles = [];
		$$("input").forEach((input) => {
			if (input.type === "checkbox") input.checked = false;
			else input.value = "";
		});
		if (dateSelect) dateSelect.value = "";
		$$(".br-option-btn.active").forEach((btn) => btn.classList.remove("active"));
		$$(".br-is-checked").forEach((el) => el.classList.remove("br-is-checked"));
		$$(".br-is-error").forEach((el) => el.classList.remove("br-is-error"));
		$$(".br-has-error").forEach((el) => el.classList.remove("br-has-error"));
		renderUploadStatus();
	}

	function openModal() {
		const saved = loadProgress();
		if (saved && saved.step >= 1) {
			Object.assign(formData, saved.formData || {});
			restoreUi();
			if (saved.step >= 2) leadCaptured = true;
			currentStep = saved.step;
		} else {
			currentStep = 0;
		}
		modal.classList.remove("hidden");
		document.body.classList.add("br-project-start-modal-open");
		showStep(currentStep);
	}

	function hideModal() {
		modal.classList.add("hidden");
		if (window.location.hash === OPEN_HASH) history.replaceState(null, "", window.location.pathname + window.location.search);
		hideConfirmExit();
		document.body.classList.remove("br-project-start-modal-open");
	}

	function closeModal(force) {
		if (!force && currentStep >= 2 && currentStep <= totalSteps) {
			showConfirmExit();
			return;
		}
		hideModal();
		currentStep = 0;
		resetForm();
		clearProgress();
	}

	function showConfirmExit() {
		const data = i18n.exitConfirm && i18n.exitConfirm[String(currentStep)];
		if (!confirmOverlay || !data) return;
		confirmTitle.textContent = data.title || "";
		confirmMessage.innerHTML = data.message || "";
		confirmStayBtn.textContent = data.stay || "Voltar";
		confirmSkipBtn.textContent = data.skip || "Pular esta pergunta";
		confirmLeaveBtn.textContent = data.leave || "Continuar depois";
		confirmOverlay.classList.remove("hidden");
	}

	function hideConfirmExit() {
		if (confirmOverlay) confirmOverlay.classList.add("hidden");
	}

	function validateStep(step) {
		if (step === 1) {
			const fields = { nome: $('input[name="nome"]'), email: $('input[name="email"]'), telefone: $('input[name="telefone"]') };
			const valid = {
				nome: !!fields.nome.value.trim(),
				email: isValidEmail(fields.email.value),
				telefone: isValidPhone(fields.telefone.value)
			};
			Object.keys(fields).forEach((key) => {
				setFieldError(fields[key], !valid[key]);
				if (valid[key]) formData[key] = fields[key].value.trim();
			});
			return valid.nome && valid.email && valid.telefone;
		}

		if (step === 3) {
			const inputs = $$('[data-step3-inputs] input');
			if (formData.medidas_depois !== "1" && !hasAllStep3Measures()) {
				inputs.forEach((input) => setFieldError(input, !digits(input.value)));
				return false;
			}
			inputs.forEach((input) => {
				const n = digits(input.value);
				if (n) formData[input.name] = n;
				else delete formData[input.name];
			});
			return true;
		}

		if (step === 5) {
			const colors = activeValues(5);
			setGroupError(5, !colors.length);
			if (colors.length) formData.cor = colors.join(",");
			return colors.length > 0;
		}

		if (step === 6) {
			formData.eletro = $$('input[name="eletro"]:checked').map((input) => input.value);
			return true;
		}

		if (step === 8) {
			const custom = digits(depthCustom && depthCustom.value);
			const option = activeValues(8)[0];
			const ok = !!(custom || option);
			setGroupError(8, !ok);
			if (ok) formData.profundidade = custom ? `${custom}cm` : option;
			return ok;
		}

		if (step === 10) {
			const ok = !!(dateSelect && dateSelect.value);
			setFieldError(dateSelect, !ok);
			if (ok) formData.data_compra = dateSelect.value;
			return ok;
		}

		const key = SINGLE_CHOICE_STEPS[step];
		if (key) {
			const value = activeValues(step)[0];
			if (value) formData[key] = value;
			const required = REQUIRED_STEPS.includes(step);
			setGroupError(step, required && !value);
			return !required || !!value;
		}

		return true;
	}

	function skipsDepth() {
		return !formData.bancada || formData.bancada === "nao-precisa";
	}

	function advance() {
		const from = currentStep;
		let to = from + 1;
		if (from === 7 && skipsDepth()) to = 9;
		showStep(to);
	}

	function nextStep() {
		if (currentStep >= totalSteps) return;
		if (!validateStep(currentStep)) return;
		if (STEP_EVENTS[currentStep]) track(STEP_EVENTS[currentStep]);
		if (currentStep === 1) captureLead();
		advance();
	}

	function skipCurrentStep() {
		hideConfirmExit();
		if (currentStep === 3) {
			formData.medidas_depois = "1";
			syncStep3();
		}
		if (currentStep < totalSteps) {
			advance();
			return;
		}
		submitForm(true);
	}

	function goBack() {
		if (currentStep > totalSteps) {
			showStep(totalSteps);
			return;
		}
		if (currentStep === 0) {
			closeModal();
			return;
		}
		let to = currentStep - 1;
		if (to === 8 && skipsDepth()) to = 7;
		showStep(to);
	}

	function mapVal(map, slug) {
		if (slug === undefined || slug === null || slug === "") return "";
		return Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : slug;
	}

	function phoneWithDdi() {
		const d = digits(formData.telefone);
		return d ? "55" + d : "";
	}

	function createFieldBag() {
		const bag = new Map();
		return {
			push(name, value) {
				if (name && value !== "" && value != null) bag.set(name, String(value));
			},
			list() {
				NEVER_SEND_DIRECTLY.forEach((name) => bag.delete(name));
				return Array.from(bag, ([name, value]) => ({ name, value }));
			}
		};
	}

	function pushContact(bag) {
		bag.push(FIELD_MAP.nome, `${formData.nome || ""}`.trim());
		bag.push(FIELD_MAP.email, `${formData.email || ""}`.trim());
		bag.push(FIELD_MAP.telefone, phoneWithDdi());
		bag.push(FIELD_MAP.cta, attribution.cta || "");
		HIDDEN_FIELDS.forEach((f) => bag.push(f.name, f.value));
	}

	function buildFields(extra) {
		const bag = createFieldBag();
		pushContact(bag);

		bag.push(FIELD_MAP.formato, mapVal(VALUE_MAP.formato, formData.formato));

		const walls = [1, 2, 3]
			.map((i) => ({ i, cm: digits(formData[`parede${i}`]) }))
			.filter((w) => w.cm)
			.map((w) => `Parede ${w.i}: ${w.cm}cm`);
		if (!walls.length && formData.medidas_depois === "1") walls.push("Enviará as medidas depois, com seu especialista");
		bag.push(FIELD_MAP.medidas, walls.join(", "));

		bag.push(FIELD_MAP.linha, mapVal(VALUE_MAP.linha, formData.linha));

		const cores = `${formData.cor || ""}`.split(",").filter(Boolean).map((s) => mapVal(VALUE_MAP.cor, s));
		bag.push(FIELD_MAP.cor, cores.join(";"));

		const eletro = (Array.isArray(formData.eletro) ? formData.eletro : []).map((s) => mapVal(VALUE_MAP.eletro, s));
		bag.push(FIELD_MAP.eletro, eletro.join(";"));

		bag.push(FIELD_MAP.bancada, mapVal(VALUE_MAP.bancada, formData.bancada));
		bag.push(FIELD_MAP.profundidade, mapVal(VALUE_MAP.profundidade, formData.profundidade));
		bag.push(FIELD_MAP.espaco, mapVal(VALUE_MAP.espaco, formData.espaco));

		const date = `${formData.data_compra || ""}`.split("-");
		if (date.length >= 2) bag.push(FIELD_MAP.data_compra, String(Date.UTC(+date[0], +date[1] - 1, 1)));

		bag.push(FIELD_MAP.orcamento, mapVal(VALUE_MAP.orcamento, formData.orcamento));

		(extra || []).forEach((f) => bag.push(f.name, f.value));
		return bag.list();
	}

	function buildEarlyCaptureFields() {
		const bag = createFieldBag();
		pushContact(bag);
		return bag.list();
	}

	function postToHubspot(fields, opts) {
		const options = opts || {};
		const context = { pageUri: window.location.href, pageName: document.title };
		const hutk = getHutk();
		if (hutk) context.hutk = hutk;
		if (options.ipAddress) context.ipAddress = options.ipAddress;

		const payload = { fields, context };
		if (options.includeConsent !== false) payload.legalConsentOptions = LEGAL_CONSENT;

		return fetch(options.url || SUBMIT_URL, {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify(payload),
			keepalive: !!options.keepalive
		}).then((res) =>
			res.json().catch(() => ({})).then((data) => {
				if (!res.ok) {
					console.error("[br-modal-projeto]", res.status, data);
					throw new Error((data && data.message) || `Não foi possível enviar o formulário (${res.status}).`);
				}
				return data;
			})
		);
	}

	function getIp() {
		const timeout = new Promise((resolve) => setTimeout(() => resolve(""), 1500));
		const request = fetch("https://api.ipify.org?format=json")
			.then((r) => r.json())
			.then((d) => d.ip || "")
			.catch(() => "");
		return Promise.race([request, timeout]);
	}

	function captureLead() {
		if (leadCaptured || !EARLY_CAPTURE_SUBMIT_URL) return;
		leadCaptured = true;
		postToHubspot(buildEarlyCaptureFields(), { url: EARLY_CAPTURE_SUBMIT_URL, includeConsent: false })
			.catch((err) => console.error("[br-modal-projeto] captação antecipada", err));
	}

	function recordExit(slug) {
		if (!slug) return;
		postToHubspot(
			buildFields([
				{ name: EXIT_FIELD, value: slug },
				{ name: "origem_de_cadastro_staging", value: ORIGIN_EXIT },
				{ name: "origem_de_cadastro__crm__staging", value: ORIGIN_EXIT }
			]),
			{ keepalive: true }
		).catch((err) => console.error("[br-modal-projeto] desistência", err));
	}

	function submitFiles(email, files) {
		if (!FILE_FORM_ID || !files.length) return;
		try {
			const frameName = "br-mpq-file-upload-frame";
			if (!document.getElementById(frameName)) {
				const iframe = document.createElement("iframe");
				iframe.name = frameName;
				iframe.id = frameName;
				iframe.style.display = "none";
				document.body.appendChild(iframe);
			}

			const form = document.createElement("form");
			form.action = FILE_UPLOAD_URL;
			form.method = "POST";
			form.enctype = "multipart/form-data";
			form.target = frameName;
			form.style.display = "none";

			const addHidden = (name, value) => {
				const input = document.createElement("input");
				input.type = "hidden";
				input.name = name;
				input.value = value;
				form.appendChild(input);
			};
			addHidden("email", email || "");
			addHidden("hs_context", JSON.stringify({ pageUri: window.location.href, pageName: document.title, hutk: getHutk() }));

			const fileInput = document.createElement("input");
			fileInput.type = "file";
			fileInput.name = FILE_FIELD;
			fileInput.multiple = true;
			const dt = new DataTransfer();
			files.forEach((f) => dt.items.add(f));
			fileInput.files = dt.files;
			form.appendChild(fileInput);

			document.body.appendChild(form);
			form.submit();
			setTimeout(() => form.remove(), 30000);
		} catch (err) {
			console.error("[br-modal-projeto] upload", err);
		}
	}

	function validateFiles(files) {
		let total = 0;
		for (const file of files) {
			const isImage = file.type.indexOf("image/") === 0;
			const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
			if (!isImage && !isPdf) return "Envie apenas imagens ou PDF no campo de anexo do ambiente.";
			if (file.size > MAX_FILE_BYTES) return `O arquivo "${file.name}" deve ter no máximo ${MAX_FILE_MB}MB.`;
			total += file.size;
		}
		if (total > MAX_FILE_BYTES) {
			return `Os arquivos somam ${Math.ceil(total / (1024 * 1024))}MB. O total deve ter no máximo ${MAX_FILE_MB}MB.`;
		}
		return null;
	}

	function setSubmitLoading(loading) {
		const btn = $("[data-submit]");
		if (!btn) return;
		btn.disabled = loading;
		btn.setAttribute("aria-busy", loading ? "true" : "false");
	}

	async function submitForm(skipValidation) {
		if (isSubmitting) return;
		if (!skipValidation && !validateStep(currentStep)) return;

		const fileError = validateFiles(uploadedFiles);
		if (fileError) {
			window.alert(fileError);
			return;
		}

		track("orcamento_modal");
		isSubmitting = true;
		setSubmitLoading(true);

		submitFiles(`${formData.email || ""}`.trim(), uploadedFiles.slice());

		try {
			const ip = await getIp();
			await postToHubspot(buildFields(ORIGIN_STAGING_NORMAL), { ipAddress: ip });
			track("success_form");
			clearProgress();
			currentStep = totalSteps + 1;
			showStep($$(".br-form-step").length - 1);
		} catch (error) {
			window.alert(error instanceof Error ? error.message : "Erro inesperado ao enviar o formulário.");
		} finally {
			isSubmitting = false;
			setSubmitLoading(false);
		}
	}

	function formatFileSize(bytes) {
		if (bytes < 1024) return `${bytes} B`;
		if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
		return `${(bytes / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`;
	}

	function syncUploadInput() {
		const input = $('input[name="step3_space_file"]');
		if (!input) return;
		try {
			const dt = new DataTransfer();
			uploadedFiles.forEach((f) => dt.items.add(f));
			input.files = dt.files;
		} catch (e) {}
	}

	function renderUploadStatus() {
		const count = uploadedFiles.length;
		let label = "";
		if (count === 1) label = i18n.uploadOne || "";
		if (count > 1 && i18n.uploadManyTpl) label = i18n.uploadManyTpl.replace(/__COUNT__/g, String(count));
		$$("[data-upload-filename]").forEach((el) => { el.textContent = label; });

		const list = $("[data-upload-list]");
		if (!list) return;
		list.innerHTML = "";
		list.hidden = !count;

		uploadedFiles.forEach((file, index) => {
			const item = document.createElement("li");
			item.className = "br-step3-upload-item";

			const name = document.createElement("span");
			name.className = "br-step3-upload-item__name";
			name.textContent = file.name;
			name.title = file.name;

			const size = document.createElement("span");
			size.className = "br-step3-upload-item__size";
			size.textContent = formatFileSize(file.size);

			const remove = document.createElement("button");
			remove.type = "button";
			remove.className = "br-step3-upload-item__remove";
			remove.setAttribute("data-upload-remove", String(index));
			remove.setAttribute("aria-label", `Remover ${file.name}`);
			remove.textContent = "×";

			item.appendChild(name);
			item.appendChild(size);
			item.appendChild(remove);
			list.appendChild(item);
		});
	}

	function addUploadFiles(files) {
		files.forEach((f) => {
			const key = `${f.name}|${f.size}|${f.lastModified}`;
			if (!uploadedFiles.some((x) => `${x.name}|${x.size}|${x.lastModified}` === key)) uploadedFiles.push(f);
		});
		syncUploadInput();
		renderUploadStatus();
	}

	function removeUploadFile(index) {
		if (index < 0 || index >= uploadedFiles.length) return;
		uploadedFiles.splice(index, 1);
		syncUploadInput();
		renderUploadStatus();
	}

	function handleOptionClick(btn) {
		const el = btn.closest(".br-form-step");
		const step = Number(el.getAttribute("data-step"));
		const group = btn.parentElement;

		if (step === 5) {
			if (btn.classList.contains("active")) btn.classList.remove("active");
			else if (group.querySelectorAll(".br-option-btn.active").length < 2) btn.classList.add("active");
			formData.cor = activeValues(5).join(",");
		} else {
			group.querySelectorAll(".br-option-btn").forEach((b) => b.classList.remove("active"));
			btn.classList.add("active");
			const key = SINGLE_CHOICE_STEPS[step];
			if (key) formData[key] = btn.getAttribute("data-value");
			if (step === 2) renderStep3();
			if (step === 8 && depthCustom) depthCustom.value = "";
			if (step === 4 || step === 7) updateToggleButtons(step);
		}

		setGroupError(step, false);
	}

	function isQuizInProgress() {
		return !modal.classList.contains("hidden") && currentStep >= 1 && currentStep <= totalSteps;
	}

	buildDateOptions();
	if (depthCustom) bindCmInput(depthCustom);

	backBtn.addEventListener("click", goBack);
	closeBtn.addEventListener("click", () => closeModal(false));
	if (successCloseBtn) successCloseBtn.addEventListener("click", () => closeModal(true));

	if (confirmStayBtn) confirmStayBtn.addEventListener("click", hideConfirmExit);
	if (confirmSkipBtn) confirmSkipBtn.addEventListener("click", skipCurrentStep);
	if (confirmLeaveBtn) {
		confirmLeaveBtn.addEventListener("click", () => {
			recordExit(EXIT_STEP[currentStep] || "");
			saveProgress();
			hideModal();
		});
	}

	win.addEventListener("beforeunload", (e) => {
		if (!isQuizInProgress()) return;
		saveProgress();
		e.preventDefault();
		e.returnValue = "";
	});

	win.addEventListener("pagehide", () => {
		if (isQuizInProgress()) saveProgress();
	});

	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "hidden" && isQuizInProgress()) saveProgress();
	});

	win.addEventListener("click", (e) => {
		if (!(e.target instanceof Element) || !e.target.closest(OPEN_SELECTOR)) return;
		e.preventDefault();
		e.stopPropagation();
		openModal();
	}, true);

	if (window.location.hash === OPEN_HASH) openModal();
	win.addEventListener("hashchange", () => {
		if (window.location.hash === OPEN_HASH && modal.classList.contains("hidden")) openModal();
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && !modal.classList.contains("hidden")) closeModal(false);
	});

	modal.addEventListener("click", (e) => {
		if (!(e.target instanceof Element)) return;

		const removeBtn = e.target.closest("[data-upload-remove]");
		if (removeBtn) {
			e.preventDefault();
			removeUploadFile(Number(removeBtn.getAttribute("data-upload-remove")));
			return;
		}

		const optionBtn = e.target.closest(".br-form-step .br-option-btn");
		if (optionBtn) handleOptionClick(optionBtn);

		syncNextBtn(currentStep);

		if (e.target.closest("[data-next-step]")) nextStep();
		if (e.target.closest("[data-submit]")) submitForm(false);
	});

	modal.addEventListener("input", (e) => {
		const target = e.target;
		if (!(target instanceof HTMLInputElement)) return;
		const name = target.name;

		if (name === "telefone") target.value = formatPhone(target.value);
		if (name === "nome" || name === "email" || name === "telefone") {
			formData[name] = target.value.trim();
			setFieldError(target, false);
		}
		if (/^parede\d$/.test(name)) {
			const n = digits(target.value);
			if (n) formData[name] = n;
			else delete formData[name];
			setFieldError(target, false);
			syncStep3();
		}
		if (name === "step8_depth_custom") {
			const n = digits(target.value);
			if (n) {
				$$('.br-form-step[data-step="8"] .br-option-btn').forEach((btn) => btn.classList.remove("active"));
				formData.profundidade = `${n}cm`;
				setGroupError(8, false);
			} else {
				delete formData.profundidade;
			}
		}
		syncNextBtn(currentStep);
	});

	modal.addEventListener("change", (e) => {
		const target = e.target;

		if (target === dateSelect) {
			formData.data_compra = dateSelect.value;
			setFieldError(dateSelect, !dateSelect.value);
			syncNextBtn(currentStep);
			return;
		}

		if (!(target instanceof HTMLInputElement)) return;

		if (target.name === "step3_medidas_depois") {
			if (target.checked) formData.medidas_depois = "1";
			else delete formData.medidas_depois;
			syncStep3();
			saveProgress();
		}

		if (target.name === "step3_space_file") {
			addUploadFiles(target.files ? Array.from(target.files) : []);
		}

		if (target.name === "eletro") {
			target.closest(".br-step6-appliance-card").classList.toggle("br-is-checked", target.checked);
			formData.eletro = $$('input[name="eletro"]:checked').map((input) => input.value);
			updateToggleButtons(6);
		}
	});
})();
